//#region Util Imports

import * as $ from 'jquery'

//#endregion

import { IReferenceType, IOpChangeState, IJsonSerializable } from '../util/interfaces'
import { Enums } from '../common/enums'
import { DataProvider } from '../../helpers/data-provider'
import { OpDescr } from './op-descr'

export class OpProductCode implements IReferenceType, IOpChangeState, IJsonSerializable {
    public idProductCode: number
    public alpha: number
    public calorificValue: number
    public code: string
    public density: number
    public idDescr: number
    public descr: OpDescr

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    //IOpChangeState implementation
    public opState: Enums.OpChangeState
    //IOpChangeState implementation end
    //IReferenceType implementation
    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdProductCode
    }
    public getReferenceKey(): number {
        return this.idProductCode
    }
    public getReferenceValue(): any {
        return this
    }
    //IReferenceType implementation end

    
    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            if (compressed || (opObj && opObj.__IC && opObj.__IC == 1)) {
                this.idProductCode = opObj.IC
                this.alpha = opObj.A
                this.calorificValue = opObj.CV
                this.code = opObj.C
                this.density = opObj.DS
                this.idDescr = opObj.I
                this.opState = opObj.O
                this.descr = opObj.D ? new OpDescr(opObj.D) : null
            } else {
                this.idProductCode = opObj.ID_PRODUCT_CODE
                this.alpha = opObj.ALPHA
                this.calorificValue = opObj.CALORIFIC_VALUE
                this.code = opObj.CODE
                this.density = opObj.DENSITY
                this.idDescr = opObj.ID_DESCR
                this.opState = opObj.OpState
                this.descr = opObj._Descr ? new OpDescr(opObj._Descr) : null
            }
        }
    }

    public toJSON(compressed: boolean = false): any {
        if (compressed) {
            return {
                IC: this.idProductCode,
                A: this.alpha,
                CV: this.calorificValue,
                C: this.code,
                DS: this.density,
                I: this.idDescr,
                O: this.opState,
                D: this.descr != null ? this.descr.toJSON(compressed) : null,
                __IC: 1
            }
        } else {
            return {
                ID_PRODUCT_CODE: this.idProductCode,
                ALPHA: this.alpha,
                CALORIFIC_VALUE: this.calorificValue,
                CODE: this.code,
                DENSITY: this.density,
                ID_DESCR: this.idDescr,
                OpState: this.opState,
                _Descr: this.descr != null ? this.descr.toJSON(compressed) : null
            }
        }
    }

    public toString() {
        if (this.descr)
            return this.descr.description
        else
            return this.code
    }

    public static loadNavigationProperties(dataProvider: DataProvider, list: OpProductCode[]): JQueryPromise<OpProductCode[]> {
        var defered = $.Deferred<OpProductCode[]>()

        defered.resolve(list)

        return defered.promise()
    }
}